// Autoplay video po otwarciu customowego modala z filmem
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const modal = mutation.target;
        
        // Gdy modal się otwiera
        if (modal.classList.contains('custom-video-modal') && modal.hasAttribute('open')) {
          const video = modal.querySelector('video');
          if (video) {
            video.muted = false;
            video.play();
          }
        }
        
        // Gdy modal się zamyka
        if (modal.classList.contains('custom-video-modal') && !modal.hasAttribute('open')) {
          // Znajdź oryginalny film w galerii produktowej
          const modalId = modal.id;
          const mediaId = modalId.replace('CustomVideoModal-', '');
          
          // Znajdź oryginalny film w galerii
          const originalVideoContainer = document.querySelector(`[data-modal="#${modalId}"]`);
          if (originalVideoContainer) {
            const originalVideo = originalVideoContainer.querySelector('video');
            if (originalVideo) {
              // Wznów autoodtwarzanie oryginalnego filmu
              originalVideo.muted = true; 
              originalVideo.loop = true; 
              originalVideo.play().catch(error => {
                console.log('Nie udało się wznowić autoodtwarzania:', error);
              });
            }
          }
        }
      }
    });
  });

  document.querySelectorAll('.custom-video-modal').forEach((modal) => {
    observer.observe(modal, { attributes: true });
  });
}

// Dodatkowe nasłuchiwanie na zamykanie modali przez przyciski X
document.addEventListener('click', function(e) {
  if (e.target.closest('.product-media-modal__toggle')) {
    const modal = e.target.closest('.custom-video-modal');
    if (modal) {
      // Krótkie opóźnienie, aby dać czas na zamknięcie modalu
      setTimeout(() => {
        const modalId = modal.id;
        const originalVideoContainer = document.querySelector(`[data-modal="#${modalId}"]`);
        if (originalVideoContainer) {
          const originalVideo = originalVideoContainer.querySelector('video');
          if (originalVideo) {
            originalVideo.muted = true;
            originalVideo.loop = true;
            originalVideo.play().catch(error => {
              console.log('Nie udało się wznowić autoodtwarzania po kliknięciu X:', error);
            });
          }
        }
      }, 100);
    }
  }
});